

<template>
  <div>
    <CRow>
      <CCol sm="12">
          <CCard>
            <CCardHeader>
              <CIcon name="cil-grid"/> ユーザー管理
              <div class="card-header-actions">
                <a
                  class="card-header-action"
                  rel="noreferrer noopener"
                  target="_blank"
                >
                  <CButton size="sm" class="mr-2" color="dark" @click="recordModal = true">編集</CButton>
                  <CButton size="sm" color="danger"  @click="deleteModal = true">削除</CButton>
                </a>
              </div>
            </CCardHeader>
            <CCardBody>
              <CCol md="8" class="offset-md-2">
                <dl v-for="(k, v) in labelDic" class="row" :key="k">
                  <dt class="col-sm-4 title-label">{{k}}</dt>
                  <dd class="col-sm-8 title-value">
                    <div v-if="v == 'id_image_urls'">
                      <div v-if="record[v] != nil">
                        <CCol md="5">
                          <div class="sm-6" v-for="src in record[v].split(',')" :key="src">
                            <img style="width: 100%" :src="src"/>
                          </div>
                        </CCol>
                      </div>
                    </div>
                    <div v-else-if="v == 'resume_image_url'">
                      <CCol md="5">
                        <div v-if="record[v] != nil">
                          <div class="sm-6" v-for="src in record[v].split(',')" :key="src">
                            <a v-if="src.indexof('pdf')" style="width: 100%" blank="target" :href="src">履歴書を確認する</a>
                            <img v-else style="width: 100%" :src="src"/>
                          </div>
                        </div>
                      </CCol>
                    </div>
                    <div v-else-if="v == 'accept_image_url'">
                      <CCol md="5">
                        <div v-if="record[v] != nil">
                          <div class="sm-6" v-for="src in record[v].split(',')" :key="src">
                            <a v-if="src.indexOf('pdf')" class="btn btn-sm btn-primary" target="blank" :href="src">合格証明書を確認する</a>
                            <img v-else style="width: 100%" :src="src"/>
                          </div>
                        </div>
                      </CCol>
                    </div>

                    <div v-else>
                      {{formatData(v, record[v])}}
                    </div>
                  </dd>
                </dl>
              </CCol>
            </CCardBody>
          </CCard>
      </CCol>
    </CRow>
    <user-modal  @hide="hideRecordModal()" :record="record" :recordModal="recordModal" :industryTypes="industryTypes"></user-modal>
    <CModal
      title="削除しますか？"
      color="danger"
      :show.sync="deleteModal"
    >
      <div class="text-center">
        <p>この業種を削除しますか？？</p>
        <p>削除してしまうと復元することはできません</p>
      </div>
      <template #footer>
        <CButton size="sm" @click="hideDeleteModal()">キャンセル</CButton>
        <CButton size="sm" color="danger" @click="deleteItem()">削除</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import UserModal from "../../components/UserModal";
import { mapGetters } from 'vuex';
export default {
  name: 'Home',
  components: {UserModal},
  data() {
    return {
      recordModal: false,
      deleteModal: false,
      record: {},
      industryTypes: [],
      industries: {},
      labelDic: {
          "id": "ID",
          "name": "姓名",
          "status": "ステータス",
          "sub": "UUID",
          "gender": "性別",
          "nationality": "国籍",
          "language": "選択言語",
          "current_address": "現在している国",
          "current_industry": "選択中の業種",
          "interested_industry": "選択業種",
          "line_id": "ラインID",
          "facebook_id": "Facebook ID",
          "payment_id": "PayPalID",
          "created_at": "作成日",
          "exam_results": "試験受講結果",
          "exam_date": "試験受講日",
          "course_industry": "受講業種",
          "exam_pass_result": "試験結果",
          "specific_skills_visa_application_date": "特定技能VISA申請日",
          "employment_hope_company": "就業希望企業名",
          "employment_status": "就業状況",
          "matching_company": "マッチング先企業",
          "workday": "入社日",
          "leave_date": "退社日",
          "id_type": "IDタイプ",
          "id_image_urls": "IDタイプの画像",
          "visa_application_status": "ビザ申請状況",
          "resume_image_url": "入国時履歴書",
          "accept_image_url": "合格証明書",
          "accept_number": "合格番号",

          "updated_at": "最終情報更新日"
      },
      states: {
        "associate_member": "仮登録",
        "no_deposite_member": "本登録(未入金)",
        "member": "本登録"
      },
      examResultStates: {
        "false": "受講前",
        "true": "受講済み",
      },
      examPassResultStates: {
        "failure": "不合格",
        "pass": "合格",
      },
      visaApplicationStatusStates: {
        "unapplied": "未申請",
        "applying": "申請中",
        "applied": "申請済み"
      },
    }
  },
  methods: {
    formatData: function(label, d) {
        if(label == "name") {
          return this.record.last_name + " " + this.record.sur_name + " " + this.record.first_name
        }
        if(label == "id_type") {
          return (d == "id")? "パスポート" : "在留カード・IDカード"
        }
        if(label == "gender") {
          return (d == "man")? "男性" : "女性"
        }
        if(label == "current_industry") {
          return this.industries[d]
        }
        if(label == "interested_industry"){
          var s = ""
          d.split(",").forEach(i => {
            s += this.industries[i] + ","
          })
          return s
        }
        if(label == "status") {
          return this.states[d]
        }
        if(label == "exam_results") {
          return this.examResultStates[d]
        }
        if(label == "exam_pass_result") {
          return this.examPassResultStates[d]
        }
        if(label == "visa_application_status") {
          return this.visaApplicationStatusStates[d]
        }
        if(label == "workday" || label == "leave_date" || label == "exam_date" || label == "specific_skills_visa_application_date") {
          return moment(d).format("YYYY/MM/DD")
        }
        if(label == "created_at" || label == "updated_at") {
          return moment(d).format("YYYY/MM/DD HH:mm")
        } else {
          return d
        }
    },
    hideRecordModal: function() {
      this.recordModal = false
    },
    updateItem: function() {
      axios
        .patch(process.env.VUE_APP_API_ENDPOINT + "/users/" + this.record.id, {"user": this.record})
        .then(() => {
          this.recordModal = false
        }).catch(error => {
          console.log(error)
        })
    },
    deleteItem: function() {
      axios
        .delete(process.env.VUE_APP_API_ENDPOINT + "/users/" + this.record.id)
        .then(() => {
          this.deleteModal = false
          this.$router.push('/dashboard')
        }).catch(error => {
          console.log(error)
        })
    }
  },
  mounted() {
    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/users/" + this.$route.params.id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          this.record = response.data.user
      }).catch(error => {
          console.log(error)
      })

    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/industries", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          response.data.industries.forEach((i) => {
            this.industries[i.id] = i.name
            this.industryTypes.push({
                value: i.id,
                label: i.name
            })
          })
      }).catch(error => {
          this.errorNotify(error.response)
      })
  },
  computed: {
    ...mapGetters({
      idToken:'GetIdToken',
    })
  },
}
</script>
<style scoped lang="scss">

/deep/ .id_image {

}
.title-label, .title-value {
  font-size: 16px;
}

</style>
